export { default } from './delete'
